// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/js/async/" + ({"354": "lib-axios","535": "lib-router",}[chunkId] || chunkId) + "." + {"144": "1974041a","264": "bf91e9b7","282": "46d01b99","31": "600d0a29","324": "23a26e93","354": "947f30a9","466": "4b3f689d","535": "a03b5894","625": "a39d942f","638": "40c5e117","640": "dc859832","689": "a9319845","787": "d3c925a7","878": "b774d1d2",}[chunkId] + ".js"
}